import { render, staticRenderFns } from "./IpoDetails.vue?vue&type=template&id=1708f03a"
import script from "./IpoDetails.vue?vue&type=script&lang=js"
export * from "./IpoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports